import { render, staticRenderFns } from "./BelposhtaCreationUser.vue?vue&type=template&id=74263d7e"
import script from "./BelposhtaCreationUser.vue?vue&type=script&lang=js"
export * from "./BelposhtaCreationUser.vue?vue&type=script&lang=js"
import style0 from "./BelposhtaCreationUser.vue?vue&type=style&index=0&id=74263d7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports